import { Component, OnInit } from '@angular/core';
import { HttpHeaders,HttpClient } from '@angular/common/http';

import { CoreService, StorageService } from './service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit{
  constructor(
    private http: HttpClient,
    private core: CoreService,
    private storag: StorageService, 
  ){ }

  ngOnInit(): void {
  }
 
}
